export type OneOf<T, V, NK extends keyof V = Exclude<keyof V, keyof any>> = {
  [K in NK]: T extends V[K] ? V[K] : never;
}[NK];

export type AtLeastOne<T, U = { [K in keyof T]: Pick<T, K> }> = Partial<T> & U[keyof U];

export type AtLeast<T, K extends keyof T> = Partial<T> & Pick<T, K>;

export type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

export type Exact<A, B> = A extends B ? (B extends A ? A : never) : never;
export type AllOrNone<T> = T | { [K in keyof T]?: never };

export type EnumKeys<Enum> = Exclude<keyof Enum, number>;
export type EnumEntries<Enum> = [EnumKeys<Enum>, Enum[EnumKeys<Enum>]];
export type EnumMemberNames<T extends object> = Extract<keyof T, string>;
export const enumObject = <Enum extends Record<string, number | string>>(e: Enum) => {
  const copy = { ...e } as { [K in EnumKeys<Enum>]: Enum[K] };
  Object.values(e).forEach((value) => typeof value === 'number' && delete copy[value]);
  return copy;
};

export const enumKeys = <Enum extends Record<string, number | string>>(e: Enum) => {
  return Object.keys(enumObject(e)) as EnumKeys<Enum>[];
};

export const enumValues = <Enum extends Record<string, number | string>>(e: Enum) => {
  return [...new Set(Object.values(enumObject(e)))] as Enum[EnumKeys<Enum>][];
};

export const enumEntries = <Enum extends Record<string, number | string>>(e: Enum) => {
  return [...new Set(Object.entries(enumObject(e)))] as EnumEntries<Enum>[];
};

export type EnsureAllKeys<E extends string | number, T extends Record<E, unknown>> = T;
